import React from 'react';
import { IconBase } from '../Base';
export const IconLayers = (props) => {
    return (React.createElement(IconBase, { ...props },
        React.createElement("g", { fill: "none", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", style: { stroke: 'var(--icon-color)' } },
            React.createElement("path", { d: "M12.8633 10.0699L17.5 12.1466L9.98917 15.4999L2.5 12.1466L7.13667 10.0758" }),
            React.createElement("path", { d: "M2.5 7.85333L9.98917 11.2075L17.5 7.85333L10.0108 4.5L2.5 7.85333Z" }))));
};
//# sourceMappingURL=Layers.js.map